import { Moment } from 'moment'
import React from 'react'
import DatesPickerDropdown from 'src/components/DatesPickerDropdown/DatesPickerDropdown'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export interface UtilityToolbarDatePickerProps {
  datePickerTitle: React.ReactElement
  since: Moment | undefined
  until: Moment | undefined
  setSince: (since: Moment | undefined) => void
  setUntil: (until: Moment | undefined) => void
  tooltip?: React.ReactElement
  disabled?: boolean | 'since' | 'until'
}

const UtilityToolbarDatePicker: React.FC<UtilityToolbarDatePickerProps> = (
  props,
): React.ReactElement => {

  return (
    <div
      css={css`
        display: flex;
        background: transparent;
        cursor: pointer;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        gap: ${variables.units['base-unit-1']}px;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;
          height: 18px;
        `}
      >
        <div>{props.datePickerTitle}</div>
        {props.tooltip}
      </div>
      <DatesPickerDropdown
        since={props.since}
        until={props.until}
        setSince={props.setSince}
        setUntil={props.setUntil}
        disabled={props.disabled}
      />
    </div>
  )
}

export default UtilityToolbarDatePicker
